import { workspaceHighlightColor } from './safeColor';

type Props = {
  color: string | null | undefined;
};

// A frame around the whole viewport, tinted with the active workspace color.
// The frame width is --spacing-workspace-frame (see index.css). The inner
// corners are rounded while the outer corners stay square/filled into the
// screen corner. The element is inset by the frame width with a transparent
// interior (the rounded hole the content shows through); a single large outer
// shadow fills everything outside it — the frame edge plus the square corner
// notches. Using one shadow (instead of an inset ring abutting an outer fill)
// avoids the antialiased hairline seam the two layers left along the rounded
// corners. Renders nothing when there is no workspace context (or the flag is
// off). Purely visual: the matching layout headroom
// (--workspace-frame-headroom) is owned by RouteWorkspaceBorder, the single
// always-mounted instance, so it stays in lockstep with the frame across
// route changes.
export const WorkspaceScreenBorder = ({ color }: Props) => {
  // Flag-gated and validated before interpolating into the box-shadow: a
  // malformed value could otherwise corrupt the rule (the 100vmax layer covers
  // the whole viewport).
  const safeColor = workspaceHighlightColor(color);

  if (!safeColor) {
    return null;
  }
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-workspace-frame z-50 rounded-(--spacing-workspace-frame)"
      data-testid="workspace-screen-border"
      style={{
        boxShadow: `0 0 0 100vmax ${safeColor}`
      }}
    />
  );
};
